<template>
    <div id="all_page" class="authentication-page row">
        <div class="authentication-page__image col-xl-4 d-none d-xl-block">
            <img src="../assets/IMGS/PNG/03_Oldies.png" alt="grandmother and grandfather" />
        </div>

        <div class="authentication-page__tabs col-12 offset-xl-2 col-xl-6">
            <TabsComponent :tabs="pageTabs" @tab-active="updateActiveTab" noWidthSet="true">
                <div class="container-fluid g-0">
                    <template v-if="activeTab == 'auth'">
                        <FormComponent
                            formName="AuthForm"
                            @response="handleFormResponse"
                            @inputErrors="updateFormErrors"
                            :action="sendResponseAuth"
                            class="row g-4 authentication-page__auth"
                        >
                            <template v-slot="{ handleInputError, checkInputError }">
                                <div>
                                    <div>
                                        <CInput
                                            v-model="auth_email_login"
                                            type="text"
                                            @error="handleInputError"
                                            :validationFunction="tools.validateEmail"
                                            ref="email_login"
                                            id="email_login"
                                            name="email_login"
                                            label="Ваша электронная почта"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="auth_password_login"
                                            type="password"
                                            @error="handleInputError"
                                            ref="password_login"
                                            id="password_login"
                                            name="password_login"
                                            label="Пароль"
                                            required
                                        />
                                    </div>
                                    <div><p id="auth_res" class="authentication-page__error"></p></div>
                                </div>
                                <div>
                                    <div>
                                        <a href="/account/forgot_password" class="plain_text_link">Забыли пароль?</a>
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        <button
                                            id="login"
                                            type="submit"
                                            value="Войти"
                                            v-on:click="checkInputError"
                                            class="ui-button ui-button--xl ui-button--secondary"
                                        >
                                            Войти
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </FormComponent>
                    </template>
                    <template v-if="activeTab == 'registration'">
                        <FormComponent
                            formName="RegistrationForm"
                            @response="handleFormResponse"
                            @inputErrors="updateFormErrors"
                            :action="sendResponseRegistration"
                            class="row g-4 authentication-page__registration"
                        >
                            <template v-slot="{ handleInputError, checkInputError }">
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_name"
                                            type="text"
                                            @error="handleInputError"
                                            ref="firstname"
                                            id="firstname"
                                            name="firstname"
                                            label="Имя"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_secondname"
                                            type="text"
                                            @error="handleInputError"
                                            ref="secondname"
                                            id="secondname"
                                            name="secondname"
                                            label="Отчество"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_email"
                                            type="text"
                                            @error="handleInputError"
                                            :validationFunction="tools.validateEmail"
                                            ref="email"
                                            id="email"
                                            name="email"
                                            label="E-mail"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_phone"
                                            type="text"
                                            @error="handleInputError"
                                            :validationFunction="tools.validatePhone"
                                            :mask="tools.formatPhone"
                                            ref="phone"
                                            id="phone"
                                            name="phone"
                                            label="Телефон"
                                            placeholder="+7 (___) ___-__-__"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_password"
                                            type="password"
                                            @error="handleInputError"
                                            ref="password"
                                            id="password"
                                            name="password"
                                            label="Пароль"
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <CInput
                                            v-model="reg_password_repeated"
                                            type="password"
                                            @error="handleInputError"
                                            ref="password_repeated"
                                            id="password_repeated"
                                            name="password_repeated"
                                            label="Пароль (повторно)"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <p id="reg_res" class="authentication-page__error"></p>
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        <p>
                                            Нажимая кнопку, я соглашаюсь с
                                            <a href="/license.pdf" target="_blank" class="plain_text_link"
                                                >условиями обработки данных</a
                                            >
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        <button
                                            id="register"
                                            type="submit"
                                            value="Зарегистрироваться"
                                            v-on:click="checkInputError"
                                            class="ui-button ui-button--xl ui-button--secondary"
                                        >
                                            Зарегистрироваться
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </FormComponent>
                    </template>
                </div>
            </TabsComponent>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { mask } from 'vue-the-mask';
import TabsComponent from './TabsComponent.vue';
import CInput from './InputComponent.vue';
import FormComponent from './FormComponent.vue';
import tools from '../assets/js/tools.js';

export default {
    name: 'authPage',
    components: {
        TabsComponent,
        CInput,
        FormComponent,
    },
    directives: { mask },
    data() {
        return {
            activeTab: 'auth',
            auth_email_login: '',
            auth_password_login: '',
            reg_name: '',
            reg_secondname: '',
            reg_phone: '',
            reg_email: '',
            reg_password: '',
            reg_password_repeated: '',
            formsStatus: [],
            pageTabs: [
                { id: 'auth', label: 'Вход' },
                { id: 'registration', label: 'Регистрация' },
            ],
            tools: tools,
        };
    },
    methods: {
        sendResponseRegistration() {
            var vm = this;
            var reg = {
                email: vm.reg_email,
                username: vm.reg_name,
                password: vm.reg_password,
                firstname: vm.reg_name,
                lastname: '',
                secondname: vm.reg_secondname,
                phone: vm.reg_phone,
            };
            var formData = JSON.stringify(reg);
            $.ajax({
                type: 'POST',
                url: global.BACKEND_URL + '/api/register',
                data: formData,
                success: function () {},
                error: function (data) {
                    console.log(data);
                    document.getElementById('reg_res').innerHTML =
                        'Пользователь с таким адресом электронной почты уже существует.<br>Воспользуйтесь функцией восстановления пароля или используйте другой адрес электронной почты.';
                },
                dataType: 'text',
                contentType: 'application/json',
            }).done(function () {
                var login = {
                    username: document.getElementById('email').value,
                    password: document.getElementById('password').value,
                };
                var formData1 = JSON.stringify(login);
                $.ajax({
                    type: 'POST',
                    url: global.BACKEND_URL + '/api/login',
                    data: formData1,
                    success: function () {},
                    error: function () {
                        document.getElementById('auth_res').innerHTML =
                            'Имя пользователя или пароль введены неправильно!';
                    },
                    dataType: 'json',
                    contentType: 'application/json',
                }).done(function (data) {
                    document.cookie = 'mtu_refresh_token=' + data['refreshToken'] + '; path=/;';
                    document.cookie = 'role=' + data['role'] + '; path=/;';
                    document.location = vm.decideWhereToRedirectAfterAuthorisation(data['role']);
                });
            });
        },
        sendResponseAuth() {
            var vm = this;
            var auth = {
                username: vm.auth_email_login,
                password: vm.auth_password_login,
            };
            var formData = JSON.stringify(auth);
            $.ajax({
                type: 'POST',
                url: global.BACKEND_URL + '/api/login',
                data: formData,
                success: function () {},
                error: function () {
                    document.getElementById('auth_res').innerHTML = 'Имя пользователя или пароль введены неправильно!';
                },
                dataType: 'json',
                contentType: 'application/json',
            }).done(function (data) {
                document.cookie = 'mtu_refresh_token=' + data['refreshToken'] + '; path=/;';
                document.cookie = 'role=' + data['role'] + '; path=/;';
                document.location = vm.decideWhereToRedirectAfterAuthorisation(data['role']);
            });
        },
        handleFormResponse(event) {
            const result = event.detail.result;
            const name = event.detail.formName;
            this.formsStatus[name] = !result;
            return result;
        },
        updateFormErrors(data) {
            this.formsStatus[data.formName] = !data.hasError;
        },
        updateActiveTab(tab) {
            var vm = this;
            console.log(tab);
            vm.activeTab = tab;
        },
        decideWhereToRedirectAfterAuthorisation(user_role) {
            console.log(`USER_ROLE: ${user_role}`);
            // if (user_role == 'User' || user_role == 'ConfirmedUser') return '/order';
            if (user_role == 'Dispatcher') return '/new_orders';
            return '/account';
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="css" scoped src="@/assets/css/auth.css"></style>

<style lang="scss">
.authentication-page {
    &__error {
        color: #ee6870;
        font-size: 16px;
        line-height: 18px;
    }
}
</style>
